import { isClinicalAdmin } from "@/routers/router-guardians"
import { RouteConfig } from "vue-router"

const routes: RouteConfig[] = [
  {
    path: "/providers",
    name: "provider-profiles",
    component: () =>
      import(/* webpackChunkName: "providers" */ "@/modules/providers/pages/provider-profiles/ProviderProfiles.vue"),
    beforeEnter(to, from, next) {
      isClinicalAdmin(to, from, next)
    }
  },
  {
    path: "/providers/:providerId",
    name: "provider-profile-details",
    props: true,

    component: () =>
      import(
        /* webpackChunkName: "providers" */ "@/modules/providers/pages/provider-profile-details/ProviderProfileDetails.vue"
      ),
    beforeEnter(to, from, next) {
      isClinicalAdmin(to, from, next)
    }
  }
]

export default routes
